module.exports = __webpack_public_path__ + "img/b-sss-2@3x.f14b13ac.png";